import React, { useState } from "react";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import Stack from "@mui/material/Stack";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Alert from "@mui/material/Alert";
import api from "../../utils/api";
import { apiUrls } from "../../utils/urls";

const SecuritySettings = () => {
  const [currentPassword, setCurrentPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmNewPassword, setConfirmNewPassword] = useState("");
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");

  const handlePasswordChangeSubmit = async (event) => {
    event.preventDefault();
    if (newPassword.length < 10) {
      resetFields();
      setError("Password must be at least 10 characters.");
      setSuccess("");
      return;
    }
    if (newPassword !== confirmNewPassword) {
      setError("New passwords don't match");
      resetFields();
      return;
    }

    const response = await api.post(apiUrls.users.password(), {
      current_password: currentPassword,
      new_password: newPassword,
    });

    if (response.data.success) {
      resetFields();
      setSuccess("Password changed successfully");
      setError("");
    } else {
      setError("Incorrrect password");
      resetFields();
    }
  };

  const resetFields = () => {
    setCurrentPassword("");
    setNewPassword("");
    setConfirmNewPassword("");
  };

  return (
    <Box>
      <Typography variant="h6">Security Settings</Typography>
      <Box
        sx={{ mt: 2 }}
        component={"form"}
        onSubmit={handlePasswordChangeSubmit}
      >
        <Typography variant="subtitle1" fontWeight={"bold"}>
          Change Password
        </Typography>
        <Stack
          spacing={2}
          sx={{
            width: "100%",
            maxWidth: "20rem",
          }}
        >
          <TextField
            required
            label="Current Password"
            type="password"
            variant="standard"
            value={currentPassword}
            onChange={(e) => setCurrentPassword(e.target.value)}
          />
          <TextField
            required
            label="New Password"
            type="password"
            variant="standard"
            value={newPassword}
            onChange={(e) => setNewPassword(e.target.value)}
          />
          <TextField
            required
            label="Confirm New Password"
            type="password"
            variant="standard"
            value={confirmNewPassword}
            onChange={(e) => setConfirmNewPassword(e.target.value)}
          />
          <Button variant="outlined" color="primary" type="submit" mt={3}>
            Submit
          </Button>
          {error && (
            <Alert
              severity="error"
              sx={{ mt: 2 }}
              onClose={() => setError(null)}
            >
              {error}
            </Alert>
          )}
          {success && (
            <Alert
              severity="success"
              sx={{ mt: 2 }}
              onClose={() => setSuccess(null)}
            >
              {success}
            </Alert>
          )}
        </Stack>
      </Box>
    </Box>
  );
};

export default SecuritySettings;
